import './PieSetter.scss';
import { Fragment, ReactNode } from 'react';
import { PieChart } from '@Components/PieChart';

const PIE_SIZE = 180;

interface PieSetterItem {
  value: number;
  color?: string;
  key?: string;
  name?: string;
  isci?: string;
}

interface PieSetterProps<T extends PieSetterItem> {
  data: T[];
  renderItem: (item: T) => ReactNode;
  pieFlex?: number;
}

const itemKey = (item: PieSetterItem): string => item.key ?? item.isci ?? item.name ?? '';

export const PieSetter = <T extends PieSetterItem>({
  data,
  renderItem,
  pieFlex = 0.5
}: PieSetterProps<T>) => {
  const slices = data.map(item => ({
    name: itemKey(item),
    value: item.value,
    color: item.color ?? 'white'
  }));
  const total = slices.reduce((sum, slice) => sum + slice.value, 0);

  return (
    <div className='pie-setter'>
      <div className='pie-setter-chart' style={{ flex: pieFlex }}>
        <PieChart data={slices} size={PIE_SIZE} />
        <div className='pie-setter-total'>{total}%</div>
      </div>
      <div className='pie-setter-items'>
        {data.map(item => (
          <Fragment key={itemKey(item)}>{renderItem(item)}</Fragment>
        ))}
      </div>
    </div>
  );
};
